import * as React from "react";
import * as TooltipPrimitive from "@radix-ui/react-tooltip";
import { cn } from "@githits/shared";
import { usePortalContainer } from "../../portal-context";

const TooltipProvider = TooltipPrimitive.Provider;

const Tooltip = TooltipPrimitive.Root;

const TooltipTrigger = TooltipPrimitive.Trigger;

const TooltipContent = React.forwardRef<
  React.ElementRef<typeof TooltipPrimitive.Content>,
  React.ComponentPropsWithoutRef<typeof TooltipPrimitive.Content>
>(({ className, sideOffset = 4, ...props }, ref) => {
  const container = usePortalContainer();
  return (
    <TooltipPrimitive.Portal container={container}>
      <TooltipPrimitive.Content
        ref={ref}
        sideOffset={sideOffset}
        className={cn(
          "ghw-z-50 ghw-overflow-hidden ghw-rounded-md ghw-border ghw-bg-popover ghw-px-3 ghw-py-1.5 ghw-text-sm ghw-text-popover-foreground ghw-shadow-md ghw-animate-in ghw-fade-in-0 ghw-zoom-in-95 data-[state=closed]:ghw-animate-out data-[state=closed]:ghw-fade-out-0 data-[state=closed]:ghw-zoom-out-95 data-[side=bottom]:ghw-slide-in-from-top-2 data-[side=left]:ghw-slide-in-from-right-2 data-[side=right]:ghw-slide-in-from-left-2 data-[side=top]:ghw-slide-in-from-bottom-2",
          className
        )}
        {...props}
      />
    </TooltipPrimitive.Portal>
  );
});
TooltipContent.displayName = TooltipPrimitive.Content.displayName;

export { Tooltip, TooltipTrigger, TooltipContent, TooltipProvider };
